import { api } from 'domains/api';
import { BASE_ANONYMOUS_API_ROUTES, getBaseAPIRoute } from 'domains/api/base/routes';
import { EvaluationDuration } from 'domains/calendars/types';
import { Relationship } from 'domains/client';
import { StateAbbrev } from 'utils/states';

export type SignupSchedule = {
  duration: EvaluationDuration;
  timeSlot: string;
  calendarID: string;
};

export type ScheduleSignupEvaluationRequest = {
  address: { state: StateAbbrev };
  amount?: number;
  coPay?: number;
  clientFirstName: string;
  clientLastName: string;
  clientSex?: string;
  contactFirstName: string;
  contactLastName: string;
  contactTimeZone: string;
  dob: string;
  email: string;
  isClientMinor: boolean;
  phone: { mobile: string };
  relationshipToClient: Relationship;
  leadID: string;

  schedules: SignupSchedule[];
  schedulesTimezone: string;

  stripeAccountID?: string;
  entity?: string;
  stripePaymentMethodID?: string;
  skipStripePayment: boolean;
  isCommercialInsurance?: boolean;
  isInsuranceOutOfNetwork?: boolean;
  primaryInsurance?: {
    insuredFirstName: string;
    insuredLastName: string;
    insuredDob: Date;
    insuredRelationshipToClient: string;
    insurancePayer: string;
    insurancePayerName: string;
    insuredPayerType: string;
    insuredMemberID: string;
    insuredGroupID?: string;
  };
  isResumeFlow: boolean;

  prefilledAppointmentID?: number;
};

export type ScheduleSignupEvaluationResponse = {
  stripeCustomerId?: string;
  stripePaymentIntentId?: string;
  invitationLink: string;
  createdClient: {
    clientID: string;
    createdClient: {
      client: {
        clientFirstName: string;
        clientLastName: string;
      };
      primaryContact: {
        email: string;
        mobilePhone: string;
        contactTimeZone: string;
      };
      careTeam: {
        therapistEmail: string;
        acuityCalendarID: string;
        acuityTimeZone: string;
      };
    };
  };
};

export const scheduleEvaluationFromSignupV3 = (
  data: ScheduleSignupEvaluationRequest,
): Promise<ScheduleSignupEvaluationResponse> => {
  return api.proxy.post<ScheduleSignupEvaluationResponse>(
    getBaseAPIRoute(BASE_ANONYMOUS_API_ROUTES.billing.signup),
    data,
  );
};
